import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the FormatHometimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatHometime',
})
export class FormatHometimePipe implements PipeTransform {
  /**
   * Takes a job and return the hometime in a human readable format for
   * displaying on the job card
   */
  transform(job: any, ...args) {
    let homeTimeTypes = {
      daily: 'Daily',
      eotherday: 'Every Other Day',
      onedayweek: '1 Day/Wk',
      twodayweek: '2 Days/Wk',
      weekly: 'Weekly',
      weekends: 'Weekends',
      eother2weeks: 'Every 2 Wks',
      eother3weeks: 'Every 3 Wks',
      monthly: 'Monthly',
      xDays: 'Custom',
      calltodiscuss: 'Call to Discuss',
      varies: 'Varies',
    };

    // CUSTOM HOMETIME MESSAGE
    if (_.get(job, 'homeTimeCustom.length')) {
      return job.homeTimeCustom;
    }
    // OTHERWISE, PRE-SELECTED HOMETIME VALUE
    else if (!_.get(job, 'homeTimeCustom.lenght')) {
      // console.log('returning jobHometime');
      if (job.homeTime) {
        // console.log('returning jobHometime normal');
        return homeTimeTypes[job.homeTime];
      } else {
        // console.log('jobHometime N/A');
        return 'Call to Discuss';
      }
    } else {
      // console.log('jobHometime N/A couldnt find');
      return 'Call to Discuss';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-hometime/format-hometime.ts